import Footer from "./Footer";
import LandHeader from "./LandHeader";
import { Link } from "react-router-dom";
import {useMediaQuery} from "beautiful-react-hooks";
import { useEffect, useState } from "react";
import {useNavigate, useLocation} from "react-router-dom";

import axios from "axios";
import { MdContentCopy } from "react-icons/md";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { toast } from "react-toastify";
import SimpleAccordion from "./SimpleAccordion";


const BASEURL = 'https://api.sinatether.com/Auth/request_listing_coins/'

export default function Hamster(){

    const isSmall = useMediaQuery('(max-width: 768px)')
    const navigate = useNavigate();

    const[Auth,setAuth] = useState(false) 
    const [isCopied, setIsCopied] = useState(false);

    const[inviteLink,setInviteLink] = useState('')
    const [Phone,setPhone] = useState("")
    const [error,seterror] = useState('')
    const [loadingp,setLoadingp] = useState(false)

    var source = 'Hamster'

    const fetchToken = async (Phone,token,source)=>{
        return axios.post(BASEURL,{'phone':Phone,"currency":'HAMSTER','source':source},
            {withCredentials:true})
    }



    document.title = 'صرافی همستر کامبت در ایران'
    document.getElementsByTagName("META")[3].content= 'با توجه به پیشرو بودن سینا تتر در تنوع ارزهای دیجیتال، اولین صرافی همستر کامبت Hamster Kombat در ایران خواهد بود و امکان معاملات خرید و فروش آن را فراهم می‌کند.'

    const onCopyText = () => {
        setIsCopied(true);
        toast.dismiss()
        
        toast.warning(' کپی شد!', {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            });
};


var canonical = document.querySelector('link[rel="canonical"]');
if (canonical !== null) {
canonical.href = `https://sinatether.com/hamster-kombat-exchange`;
}


    useEffect(()=>{
        axios.get('https://api.sinatether.com/Auth/GetDetailsAccount',{withCredentials:true}).then((res)=>{
            if (res.status == 200){

                setAuth(true)
                setInviteLink(res.data['ref'])

            }
        }).catch((error)=>{

            setAuth(false)
        })
    },[])







    function HandelClick(event) {
        event.preventDefault()
    
    
    
    
    
    
        if (!Phone || Phone.length < 11 ){
            toast.error("لطفا شماره تلفن خود را به درستی وارد نمایید")
            return
        }
    
        setLoadingp(true)
    
    
    
    
    
    
    
            fetchToken(Phone,'',source).then(
                (res) => {
                    console.log(res)
                    if (res.data['status'] == 200) {


                        toast.success(res.data['message'])
                        setLoadingp(false)

    
     
     
                    }else {
                        toast.warning(res.data['message'])
                        setLoadingp(false)
     
                    }
                }
     
     
            )
    
        
           
    
       }
    




    
   function handelCheck(event){
    var pattern = new RegExp(/^09[0-9]{9}/);
    var pattern1 =  new RegExp(/^@#@_[0-9]{2}/)
    let p = event.target.value
    if (pattern1.test(p)){
        if (p.length == 6){
            seterror('')
            setPhone(p)
            return
        }
    }








   /*if(p.length==11)
   {*/
       if (!pattern.test(p))
        {
        seterror('لطفا شماره تلفن خود را درست وارد نمایید')
        }else if(p.length==11) {
           seterror('')
           setPhone(p)
       }
       else {
                       seterror('لطفا شماره تلفن خود را درست وارد نمایید')
       }
  /* }
   else {
       seterror('شماره تلفن وارد شده صحیح نیست!')
   }*/


}




    return(

        <div id="main-wrapper" className={"show"}>



            <LandHeader/>

            <div className="back-hamster">


                <div className="right-item-hamster">

                <h1 className="h1-hamster">صرافی همستر کامبت در ایران</h1>


                <div>

                <p className="fjhsfhs52674855jsjugfsf">
با وارد کردن شماره تماس خود، جزو اولین نفراتی باشید که از لیست شدن آن و امکان خرید و فروش Hamster Kombat آگاه می‌شوید.
</p>





</div>

<div  className="hamster26855fnsf">
                                    
                                    <div className="subdshfhphonej424">
                                            <input type="tel" className="myinputsptia443-new" placeholder="شماره موبایل خود را وارد نمایید" maxLength={11}  onChange={handelCheck}  required/>
                                            <div>
                                                <button className="jdhsbuttoncust44-new" disabled={loadingp ? true : false} onClick={HandelClick}>
    
                                                    {loadingp ?
                                                                        <img className="jsdhshgd" src={'../img-camp/loading.svg'}/>
     
    
                                                    :
    
                                                    <>  اطلاع بده </>
    
                                                    }
    
    
    
    
                                                </button>
                                            </div>
                                        </div>
    
                                    </div>

               



                </div>

                <div className="jsfdkshffowrwrwr-2">

                <div className="w-100">


<img src="https://static.sinatether.com/images/hamster.png" alt="صرافی جایزه رایگان "/>



</div>

                </div>

            </div>

            {isSmall? 


          
<>
                    <div className="gift2023">



                        <div className="text-center">




                            


                        </div>



                        <div className="mg14-ham">

                            <div className="">








                               












                                <div className="mg-top60">
                                    
                                <p className="pknsfsf672424254">همستر کامبت (Hamster Kombat) یک بازی کریپتویی جدید در پلتفرم تلگرام است. در این بازی، کاربران با ضربه‌زدن متوالی روی صفحه گوشی، سکه‌های مجازی به نام HMSTR جمع‌آوری می‌کنند. امیدواریم که در آینده، ارزش‌گذاری این سکه‌ها افزایش یابد و کاربران بتوانند به پول نقد دست پیدا کنند.
                                این بازی به سادگی طراحی شده است و مکانیزم تپ تو اِرن (Tap to Earn) را دارد. با توجه به پیشرو بودن سینا تتر در تنوع ارزهای دیجیتال، اولین <strong>صرافی همستر کامبت</strong> در ایران خواهد بود. این موضوع را می‌توانید با مقايسه ليست ارزهای صرافی‌های دیگر و سینا تتر و زمان لیست شدن آن‌ها مشاهده کنید.

                                </p>
      <p className="pknsfsf672424254">توصیه ما در صورت تمایل به این بازی ارز دیجیتال، جمع آوری هر چه بیشتر کوین‌های همستر به طریق راه‌های موجود در این پلتفرم است. اما هميشه سعی کنید در اوقات فراغت خود به این کار بپردازید تا از کارهای اصلی خود جا نمانید.</p>

                                </div>



                                <div className="mg-top60">

                                    <p className="pknsfsf672424254">
                                    همستر کامبت یک توکن است که در مرحله پیش از عرضه (Pre Market) قرار دارد. صرافی کوکوین اعلام کرده که توکن همستر کامبت با نماد HMSTR$ در بازار پیش از عرضه لیست شده است. برای <strong>فروش همستر کامبت</strong>، می‌توانید اقدامات زیر را انجام دهید:


                                    </p>


                                    <br/>

                                    <div>
                                        
                                        <h3 className="h3-hamster">
                                        ۱.
                                        نصب کیف پول تون کوین:
                                        </h3>

                                        <p className="pknsfsf672424254">
                                          برای شروع، یک کیف پول تون کوین روی گوشی یا کامپیوتر خود نصب کنید. این کیف پول برای برداشت همستر کامبت و توکن‌های دیگر نیاز است. یکی از بهترین گزینه‌ها کیف پول تون‌ کیپر (TonKeeper) است.
                                        </p>

                                    </div>


                                    
                                    <div>
                                        
                                        <h3 className="h3-hamster">
                                        ۲. تهیه تون کوین:
                                        </h3>

                                        <p className="pknsfsf672424254">
                                        برای جابه‌جایی همستر کامبت، به مقدار کمی تون کوین نیاز دارید. به دلیل کارمزدهای پایین شبکه تون کوین، حداقل ۲ دلار تون کوین را در کیف پول خود داشته باشید¹.
                                        </p>

                                    </div>




                                    
                                    <div>
                                        
                                        <h3 className="h3-hamster">
                                        ۳. اتصال به ربات همستر کامبت: 
                                                                                </h3>

                                        <p className="pknsfsf672424254">
                                        ربات همستر کامبت امکان اتصال به کیف پول‌های تون کوین را فراهم کرده است. با اتصال کیف پول خود به ربات، می‌توانید سکه خود را برداشت کنید.
                                        </p>

                                    </div>

                                </div>



                                <div className="mg-top60 nfjsfsfsfbsfsbafsf12424254">

                                    <p className="pknsfsf672424254 text-center pb-0 mb-0">
                                    توجه داشته باشید که استفاده از کیف پول رسمی تلگرام (Telegram Wallet) به دلیل تحریم‌ها توصیه نمی‌شود، بنابراین از کیف پول‌های غیرامانی مانند تون‌ کیپر استفاده کنید.صرافی سینا تتر با فراهم شدن امکان قرارگیری آن، پشتیبان همه جانبه آن از منظر خرید و فروش این ارز خواهد بود.

                                    </p>

                                </div>





                    </div>


                 

                        </div>




                    </div>


     



</>

:



<>
                    <div className="gift2023">







                            



                        <div className="">

                            <div className="marginrl-140">

















                                <div className="mg-top60">
                                    
                                <p className="pknsfsf672424254">همستر کامبت (Hamster Kombat) یک بازی کریپتویی جدید در پلتفرم تلگرام است. در این بازی، کاربران با ضربه‌زدن متوالی روی صفحه گوشی، سکه‌های مجازی به نام HMSTR جمع‌آوری می‌کنند. امیدواریم که در آینده، ارزش‌گذاری این سکه‌ها افزایش یابد و کاربران بتوانند به پول نقد دست پیدا کنند.
                                این بازی به سادگی طراحی شده است و مکانیزم تپ تو اِرن (Tap to Earn) را دارد. با توجه به پیشرو بودن سینا تتر در تنوع ارزهای دیجیتال، اولین <strong>صرافی همستر کامبت</strong> در ایران خواهد بود. این موضوع را می‌توانید با مقايسه ليست ارزهای صرافی‌های دیگر و سینا تتر و زمان لیست شدن آن‌ها مشاهده کنید.

                                </p>
      <p className="pknsfsf672424254">توصیه ما در صورت تمایل به این بازی ارز دیجیتال، جمع آوری هر چه بیشتر کوین‌های همستر به طریق راه‌های موجود در این پلتفرم است. اما هميشه سعی کنید در اوقات فراغت خود به این کار بپردازید تا از کارهای اصلی خود جا نمانید.</p>

                                </div>



                                <div className="mg-top60">

                                    <p className="pknsfsf672424254">
                                    همستر کامبت یک توکن است که در مرحله پیش از عرضه (Pre Market) قرار دارد. صرافی کوکوین اعلام کرده که توکن همستر کامبت با نماد HMSTR$ در بازار پیش از عرضه لیست شده است. برای <strong>فروش همستر کامبت</strong>، می‌توانید اقدامات زیر را انجام دهید:


                                    </p>


                                    <br/>

                                    <div>
                                        
                                        <h3 className="h3-hamster">
                                        ۱.
                                        نصب کیف پول تون کوین:
                                        </h3>

                                        <p className="pknsfsf672424254">
                                          برای شروع، یک کیف پول تون کوین روی گوشی یا کامپیوتر خود نصب کنید. این کیف پول برای برداشت همستر کامبت و توکن‌های دیگر نیاز است. یکی از بهترین گزینه‌ها کیف پول تون‌ کیپر (TonKeeper) است.
                                        </p>

                                    </div>


                                    
                                    <div>
                                        
                                        <h3 className="h3-hamster">
                                        ۲. تهیه تون کوین:
                                        </h3>

                                        <p className="pknsfsf672424254">
                                        برای جابه‌جایی همستر کامبت، به مقدار کمی تون کوین نیاز دارید. به دلیل کارمزدهای پایین شبکه تون کوین، حداقل ۲ دلار تون کوین را در کیف پول خود داشته باشید¹.
                                        </p>

                                    </div>




                                    
                                    <div>
                                        
                                        <h3 className="h3-hamster">
                                        ۳. اتصال به ربات همستر کامبت: 
                                                                                </h3>

                                        <p className="pknsfsf672424254">
                                        ربات همستر کامبت امکان اتصال به کیف پول‌های تون کوین را فراهم کرده است. با اتصال کیف پول خود به ربات، می‌توانید سکه خود را برداشت کنید.
                                        </p>

                                    </div>

                                </div>



                                <div className="mg-top60 nfjsfsfsfbsfsbafsf12424254">

                                    <p className="pknsfsf672424254 text-center pb-0 mb-0">
                                    توجه داشته باشید که استفاده از کیف پول رسمی تلگرام (Telegram Wallet) به دلیل تحریم‌ها توصیه نمی‌شود، بنابراین از کیف پول‌های غیرامانی مانند تون‌ کیپر استفاده کنید.صرافی سینا تتر با فراهم شدن امکان قرارگیری آن، پشتیبان همه جانبه آن از منظر خرید و فروش این ارز خواهد بود.

                                    </p>

                                </div>





                    </div>


                 

                        </div>




                    </div>


     

                    <div className="just-center  ">

                    <div className="lastttx">
                    با سینا تتر پازل سرمایه گذاری تو کامل کن !

                    </div>

                    <div className="mdfhsyfsf354 ">

                    <Link to={'/login'}>

                    <button className="btn btnsjhrsrbr35">
                    همین الان ثبت نام کن !
                    </button>

                    </Link>

                    </div>
                    </div>

</>

            }


            


            <Footer/>

            



        
        
        </div>
    )
}